<div class="about-container">
  <div class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">{{ 'about.hero_title' | translate }}</h1>
      <p class="hero-subtitle">{{ 'about.hero_subtitle' | translate }}</p>
    </div>
  </div>

  <div class="content-wrapper">
    <section class="company-info">
      <div class="info-card">
        <h2>{{ 'about.company_name' | translate }}</h2>
        <div class="company-meta">
          <span class="founded">{{ 'about.founded' | translate }}</span>
          <span class="location">📍 {{ 'about.location' | translate }}</span>
        </div>
        <p class="company-description">
          {{ 'about.company_description' | translate }}
        </p>
      </div>
    </section>

    <section class="services-section">
      <h2>{{ 'about.services_title' | translate }}</h2>
      <div class="services-grid">
        <div class="service-card">
          <div class="service-icon">🏠</div>
          <h3>{{ 'about.service_buy_sell_title' | translate }}</h3>
          <p>{{ 'about.service_buy_sell_description' | translate }}</p>
        </div>
        <div class="service-card">
          <div class="service-icon">🔑</div>
          <h3>{{ 'about.service_rent_title' | translate }}</h3>
          <p>{{ 'about.service_rent_description' | translate }}</p>
        </div>
        <div class="service-card">
          <div class="service-icon">🌐</div>
          <h3>{{ 'about.service_website_title' | translate }}</h3>
          <p>{{ 'about.service_website_description' | translate }}</p>
        </div>
      </div>
    </section>

    <section class="values-section">
      <h2>{{ 'about.values_title' | translate }}</h2>
      <div class="values-grid">
        <div class="value-item">
          <h3>{{ 'about.value_free_title' | translate }}</h3>
          <p>{{ 'about.value_free_description' | translate }}</p>
        </div>
        <div class="value-item">
          <h3>{{ 'about.value_simple_title' | translate }}</h3>
          <p>{{ 'about.value_simple_description' | translate }}</p>
        </div>
        <div class="value-item">
          <h3>{{ 'about.value_fast_title' | translate }}</h3>
          <p>{{ 'about.value_fast_description' | translate }}</p>
        </div>
        <div class="value-item">
          <h3>{{ 'about.value_reliable_title' | translate }}</h3>
          <p>{{ 'about.value_reliable_description' | translate }}</p>
        </div>
      </div>
    </section>

    <section class="vision-section">
      <div class="vision-card">
        <h2>{{ 'about.vision_title' | translate }}</h2>
        <p>
          {{ 'about.vision_description' | translate }}
        </p>
        <div class="expansion-info">
          <div class="expansion-item">
            <div class="expansion-icon">🚀</div>
            <h3>{{ 'about.expansion_growth_title' | translate }}</h3>
            <p>{{ 'about.expansion_growth_description' | translate }}</p>
          </div>
          <div class="expansion-item">
            <div class="expansion-icon">🤝</div>
            <h3>{{ 'about.expansion_partnerships_title' | translate }}</h3>
            <p>{{ 'about.expansion_partnerships_description' | translate }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="contact-section">
      <h2>{{ 'about.contact_title' | translate }}</h2>
      <div class="contact-grid">
        <div class="contact-card">
          <div class="contact-icon">📧</div>
          <h3>{{ 'about.contact_support_title' | translate }}</h3>
          <p>{{ 'about.contact_support_description' | translate }}</p>
          <a href="mailto:support@zexapp.com" class="contact-link">support&#64;zexapp.com</a>
        </div>
        <div class="contact-card">
          <div class="contact-icon">💼</div>
          <h3>{{ 'about.contact_business_title' | translate }}</h3>
          <p>{{ 'about.contact_business_description' | translate }}</p>
          <a href="mailto:office@zexapp.com" class="contact-link">office&#64;zexapp.com</a>
        </div>
        <div class="contact-card">
          <div class="contact-icon">📱</div>
          <h3>{{ 'about.contact_social_title' | translate }}</h3>
          <p>{{ 'about.contact_social_description' | translate }}</p>
          <a href="https://www.facebook.com/profile.php?id=61572955446559" target="_blank" class="contact-link">Facebook</a>
        </div>
      </div>
    </section>
  </div>
</div>
